module.exports = __webpack_public_path__ + "static/media/krpc.ce4aaed4.png";